/* import __COLOCATED_TEMPLATE__ from './pretty-num-input.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { userEntryToNumber, eng3, eng4 } from '@ebiz/pretty-num';

////////////////////////////////////////////////////////////////////////////////////
// pretty-num-input - This is the Base Textbox Component used by the application  //
////////////////////////////////////////////////////////////////////////////////////

export default class PrettyNumInput extends Component {
  tagName = '';

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('model', 'precision') get value() {
    let value = this.model;
    let result = this.precision === 4 ? eng4(value) : eng3(value);
    return result;
  }
  set value(value) {
    return value; //eslint-disable-line no-setter-return
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action onValueChanged(evt) {
    if (this.value !== evt.target.value) {
      var isValidInput =
        /^-?(\d*\.)?\d*[EafpnuµmkMGT]?$/.test(evt.target.value) && !isNaN(userEntryToNumber(evt.target.value, NaN));
      if (isValidInput) {
        let oldValue = this.model;
        let newValue = userEntryToNumber(evt.target.value);
        this.set('value', this.precision === 4 ? eng4(newValue) : eng3(newValue));
        if (this.updateField) {
          this.updateField(this.fieldId, newValue);
        }
        if (oldValue === newValue) {
          // If the user enters the same value but different format, we have to update the display value as well
          // ex. Textbox contains 3.5k and user enters 3500
          evt.target.value = this.value;
        }
      } else {
        evt.target.value = this.value;
      }
    }
  }
}
